// Shared utility for extracting labels from CMS components
export const returnLabel = (labelArray, key) => {
    if (labelArray && labelArray.length > 0 && key) {
        return labelArray.find((x) => x.Key === key)?.Phrase || "";
    }
    return "";
};

// Generic CMS label getter
export const getLabelFromCmsComponent = (pageContent, componentKey, key) => {
    if (pageContent && pageContent[componentKey]) {
        const cmsDataLabel = pageContent[componentKey];
        return returnLabel(cmsDataLabel?.Labels, key);
    }
    return "";
};

// Referral-specific CMS fetchers
export const getReferralCmsFetchers = (referralsCMSData) => {
    const pageContent = referralsCMSData?.pageContent || {};

    return {
        fetchAssignRefReqLabel: (key) =>
            getLabelFromCmsComponent(pageContent, "AssignReferralRequest", key),
        fetchAssignRefReqListLabel: (key) =>
            getLabelFromCmsComponent(pageContent, "AssignReferralRequestsList", key),
        fetchManageRefReqLabel: (key) =>
            getLabelFromCmsComponent(pageContent, "ManageReferralRequest", key),
        fetchManageRefReqListLabel: (key) =>
            getLabelFromCmsComponent(
                pageContent,
                "ManageReferralRequestList",
                key
            ),
        fetchCommonCMSLabel: (key) =>
            getLabelFromCmsComponent(pageContent, "CommonComponent", key),
    };
};
